<script setup lang="ts">
import { inject, computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import type { Ref } from 'vue';
import type { Viewer, Nullable } from '@immersive-tech/viewer-engine';
import type { IManifest } from '@/types/IManifest';

const router = useRouter();
const route = useRoute();

const routeBeforePreviewInitialized = ref(route.path);
const viewer = inject('viewer') as Ref<Nullable<Viewer>>;
const manifest = inject('manifest') as Ref<IManifest>;

const isInPreviewMode = computed(() => route.path === '/preview');
const enablePreviewButton = computed(() => {
  if (!viewer.value) return false;
  if (manifest.value.parts.length === 0) return false;

  return viewer.value.entities.size > 0;
});

const doPreview = () => {
  if (!enablePreviewButton.value) return;

  if (isInPreviewMode.value === true) {
    router.push(routeBeforePreviewInitialized.value);
  } else {
    routeBeforePreviewInitialized.value = route.path;

    router.push('/preview');
  }
};
</script>

<template>
  <button
    class="px-2 py-1 text-sm rounded-sm cursor-pointer"
    :class="{
      'bg-lime-600 text-white': enablePreviewButton === true && isInPreviewMode === false,
      'bg-red-600 text-white': enablePreviewButton === true && isInPreviewMode === true,
      'bg-gray-300 text-white': enablePreviewButton === false
    }"
    type="button"
    @click="doPreview"
  >
    <span>
      {{ isInPreviewMode ? 'End' : 'Start' }} Preview
    </span>
  </button>
</template>
